<div class="image-card"
     [class.inactive]="!cardChecked"
     [class.active]="cardChecked"
     [class.show-checkbox]="showCheckbox"
     (click)="onElementClick($event)">
    <div class="image-card__header" *ngIf="!loadingImage">
        <p class="image-card__header__title" *ngIf="!loadingImage">
            <mat-icon *ngIf="image.shared" class="material-icons-round info" matTooltip="{{'GENERAL.SHARED_RESOURCE' | translate}}">
                star_half
            </mat-icon>
            {{ getImageName(image.name) }}
        </p>
        <app-checkbox
                [checked]="cardChecked"
                [disableRipple]="true"
                [labelPosition]="'before'"
                (changeEvent)="onCheckImage()">
        </app-checkbox>
    </div>
    <app-loader class="image-card__loader" *ngIf="loadingImage"></app-loader>
    <div class="image-card__wrapper" *ngIf="!loadingImage">
        <mat-icon *ngIf="image.type === typeVideo" class="material-icons-round custom-icon" svgIcon='play_video'></mat-icon>
        <img [src]="imageBytes" alt="image">
    </div>
</div>